import * as Yup from "yup";
import moment from "moment";
import {
  EmployeeAttendanceLocationType,
} from "./constants/employee-attendance.constants";

const schema = Yup.object().shape({
  employeeId: Yup.number().required(),
  isHalfDay: Yup.boolean().optional(),
  remarks: Yup.string(),
  inLocationType: Yup.mixed<EmployeeAttendanceLocationType>()
    .oneOf(Object.values(EmployeeAttendanceLocationType))
    .nullable()
    .optional(),
  outLocationType: Yup.mixed<EmployeeAttendanceLocationType>()
    .oneOf(Object.values(EmployeeAttendanceLocationType))
    .nullable()
    .optional(),
  inTime: Yup.string()
    .nullable()
    .optional()
    .test("in-time-format", "Invalid in time", (value) => {
      if (!value) return true;
      return moment(value, "HH:mm", true).isValid();
    }),
  outTime: Yup.string()
    .nullable()
    .optional()
    .test(
      "out-needs-in",
      "Out time requires in time",
      function validateOutNeedsIn(value) {
        if (!value) return true;
        return !!this.parent.inTime;
      },
    )
    .test(
      "out-after-in",
      "Out time cannot be before in time",
      function validateOutAfterIn(value) {
        if (!value || !this.parent.inTime) return true;
        const out = moment(value, "HH:mm", true);
        const inTime = moment(this.parent.inTime, "HH:mm", true);
        if (!out.isValid() || !inTime.isValid()) return false;
        return out.isSameOrAfter(inTime);
      },
    ),
});

export default schema;
